export var TAlertStatus;
(function (TAlertStatus) {
    TAlertStatus["SUCCESS"] = "success";
    TAlertStatus["ERROR"] = "error";
    TAlertStatus["INFO"] = "info";
    TAlertStatus["WARNING"] = "warning";
    TAlertStatus["DEFAULT"] = "default";
})(TAlertStatus || (TAlertStatus = {}));
export var TAlertType;
(function (TAlertType) {
    TAlertType["GENERAL"] = "GENERAL";
    TAlertType["PRINT_EXPORT"] = "PRINT_EXPORT";
    TAlertType["MULTI_ACTIONS"] = "MULTI_ACTIONS";
    TAlertType["TOGGLE"] = "TOGGLE";
    TAlertType["PAGE_LOAD_ERROR"] = "PAGE_LOAD_ERROR";
})(TAlertType || (TAlertType = {}));
